<template>
	<div>
		<div class="stream-display" @dblclick.stop="toggleBg">
			<img class="pointer absolute min-w-100 min-h-100 object-cover" :class="{'z-index-min1': visibleElements.length === 0}" v-if="backgroundColor === '#FFFFFF' && !isBgToggled" :src="imgTransparentCheckerDark" alt="Grafias">
			<img class="pointer absolute min-w-100 min-h-100 object-cover" :class="{'z-index-min1': visibleElements.length === 0}" v-if="backgroundColor === '#FFFFFF' && isBgToggled" :src="imgTransparentChecker" alt="Grafias" >
			<img :src="safeRuleThird" alt="Grafias" class="absolute z-index-99 min-w-100 disabled min-h-100 object-cover">
			<!-- boundarary -->
			<!-- <div v-show="heightDisplay > widthDisplay && heightDisplay < 1920" class="absolute z-index-99 pointer-events-none" :style="{width: `${(((heightDisplay / 9) * 16) - widthDisplay) / 2 }px`, height: `${heightDisplay}px`, backgroundColor: 'black'}"></div>
			<div v-show="heightDisplay > widthDisplay && heightDisplay < 1920" class="absolute z-index-99 pointer-events-none" :style="{width: `${(((heightDisplay / 9) * 16) - widthDisplay) / 2 }px`, height: `${heightDisplay}px`, backgroundColor: 'black', marginLeft: 'auto'}"></div> -->
			<transition name="fade">
				<span class="pointer">
					<div class="transition containerLogoGrafias">
						<span v-show="visibleElements.length === 0" @dblclick.stop="toggleBg" class="z-index-1">
							<span class="helper"></span>
							<img :src="activeBgColor" alt="Grafias" class="min-w-100 portrait-grafias-logo">
						</span>
					</div>
				</span>
			</transition>
			<transition-group name="transition">
				<div v-for="item in visibleElements" :key="item.id" :style="{ zIndex:item.layer_index }">
					<div>
						<stream-element
							:style="{ zIndex:item.layer_index }"
							:status="type"
							:item="item"
							:key="item.id">
						</stream-element>
					</div>
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script>
import $ from 'jquery';
import { mapActions } from 'vuex';
import dayjs from 'dayjs';
import { getAxiosErrorMessage, duplicateVar, delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import rundownsApi from '@/api/rundowns';
import StreamElement from '@/components/StreamElement.vue';

export default {
	name: 'StreamDisplayPreview',
	components: {
		StreamElement,
	},
	props: {
		type: {
			type: String,
			default: 'preview',
		},
	},
	sockets: {
		connect() {
			this.initSocket();
		},
		item_edit_preview(item) {
			this.insertItem(item, true);
		},
		item_update(item) {
			this.insertItem(item, true);
		},
		item_preview_update(item) {
			this.insertItem(item, true);
		},
		items_preview_update(items) {
			const filteredStartItems = items.filter(item => item.is_play_preview);
			const filteredStopItems = items.filter(item => !item.is_play_preview || ((item.is_play_preview && !item.is_update_preview && item.type === 'lower_third')));
			const lastItem = items && items.length > 0 ? duplicateVar(items[items.length - 1]) : null;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			if (filteredStartItems > 1 && ultimateParent) filteredStartItems.pop();

			const sortedStartItems = filteredStartItems.sort((a, b) => {
				const parsedA = JSON.parse(a.content);
				const parsedB = JSON.parse(b.content);
				return (parsedA.childOrder < parsedB.childOrder) ? -1 : 1;
			});
			for (let index = 0; index < filteredStopItems.length; index++) {
				const item = filteredStopItems[index];
				// find updated audio for fadeout
				const indexVisibleElement = this.visibleElements.findIndex(({ id }) => id === item.id);
				const idAudio = item.type === 'audio' && !item.is_play_preview && this.visibleElements && this.visibleElements[indexVisibleElement] && this.visibleElements[indexVisibleElement].id;
				// insert item update
				this.insertItem(item, true, idAudio);
			}

			if (sortedStartItems.length > 0) {
				this.waitAndPlay(sortedStartItems, 0, lastItem);
			}
		},
		item_bulk_delete(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.removeItem(item);
			}
		},
		item_delete(id) {
			if (id) {
				this.removeItem(parseInt(id));
			}
		},
		rundown_stop(items) {
			this.onStopAll(items);
		},
		rundown_preview_stop(items) {
			this.onStopAllPreview(items);
		},
		rundown_background(item) {
			this.backgroundColor = item.background_color;
			$('html.md-theme-default').css('background-color', item.background_color);
		},
	},
	data() {
		return {
			rundown: {},
			items: [],
			whiteTransparentBg: '/img/logo/Grafias_FULLHD_White_transparent2.png',
			darkTransparentBg: '/img/logo/Grafias_FULLHD_Dark_transparent2.png',
			backgroundColor: '#FFFFFF',
			imgTransparentChecker: '/img/checkertransparent_light.png',
			imgTransparentCheckerDark: '/img/checkertransparent_dark.png',
			safeRuleThird: '/img/safe_rule_third.png',
			isBgToggled: false,
			// portrait
			widthDisplay: 0,
			heightDisplay: 0,
		};
	},
	created() {
		this.initSocket();
		this.$nextTick(() => {
			$('body').css('background-color', 'transparent');
			$('html.md-theme-default').css('background-color', 'transparent');
			$(document).find('main').removeClass('main');
			$('html').css('overflow', 'hidden');
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
		});
		this.fetch();
	},
	destroyed() {
	},
	beforeDestroy() {
		this.leaveSocket();
		this.$nextTick(() => {
			$(document).find('main').addClass('main');
			$('body').css('background-color', '');
			$('html.md-theme-default').css('background-color', '');
			$('html').css('overflow', 'visible');
			this.setNavbarVisible(true);
			this.setDrawerVisible(true);
		});
	},
	mounted() {
		// update layout on each user publish new update
		window.addEventListener('message', this.receiveMessage, false);
	},
	methods: {
		// update layout on each user publish new update
		receiveMessage(e) {
			if (e.data === 'updateOutput') {
				this.fetch(false);
			}
		},
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		waitAndPlay(items, i, lastItem) {
			const item = items && items.length > 0 ? items[i] : null;

			const nextItem = items && items.length > 0 && i < items.length - 1 ? items[i + 1] : null;
			if (item) this.insertItem(item);
			const itemContent = item && item.content ? item.content : '{}';
			const contentSortedStartItem = JSON.parse(itemContent);
			const childDuration = contentSortedStartItem && contentSortedStartItem.childOrder ? contentSortedStartItem.childOrder : 0;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			const ultimateParentContent = ultimateParent ? JSON.parse(ultimateParent.content) : null;
			const itemLength = items.length;
			const ultimateParentDuration = ultimateParentContent && ultimateParentContent.childOrder ? ultimateParentContent.childOrder : 0;
			let duration = childDuration < 0 ? (childDuration * -1) : childDuration;

			if (ultimateParent && item.id === ultimateParent.id) {
				if (nextItem) {
					const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
					const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
					if (nextChildDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}

			if (nextItem) {
				const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
				const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
				if (nextChildDuration === childDuration) {
					this.insertItem(nextItem);
					duration = 0;
				} else {
					// eslint-disable-next-line no-lonely-if
					if (childDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
					}
				}
			}
			const timeOut = setTimeout(() => { //  call a 3s setTimeout when the loop is called
				let indexInterval = i + 1;
				if (indexInterval < itemLength) { //  if the counter < 10, call the loop function
					this.waitAndPlay(items, indexInterval, lastItem); //  ..  again which will trigger another
				} //  ..  setTimeout()
				if (indexInterval === itemLength) {
					clearTimeout(timeOut);
					indexInterval = 0;
				}
			}, duration);
		},
		toggleBg() {
			this.isBgToggled = !this.isBgToggled;
		},
		initSocket() {
			this.$socket.client.emit('join', this.room);
		},
		leaveSocket() {
			this.$socket.client.emit('leave', this.room);
		},
		removeElement(item) {
			const element = document.getElementById(`${item.type}-${item.id}`);
			if (element) {
				element.remove();
			}
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
			}
		},
		insertItem(item, reset = false, fadeoutAudioId) {
			const itemId = item && item.id ? item.id : null;
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index === -1) {
				this.items.push(item);
			} else {
				const currentItemUpdatedDate = dayjs(this.items[index].updated_at);
				const newItemUpdatedDate = dayjs(item.updated_at);
				const isItemNewer = newItemUpdatedDate.isAfter(currentItemUpdatedDate);
				// eslint-disable-next-line no-lonely-if
				if (isItemNewer || reset) {
					// for non audio type assets
					if (!fadeoutAudioId) this.$set(this.items, index, item);
					// for audio type assets
					if (fadeoutAudioId) {
						delay(() => {
							this.$set(this.items, index, item);
						}, 1000);
					}
				}
			}
		},
		onStartPlay(item) {
			this.insertItem(item);
		},
		fetch(isReset = true) {
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.heightDisplay = rundown && rundown.display && rundown.display.displaySize && rundown.display.displaySize.height ? parseInt(rundown.display.displaySize.height) : 0;
				this.widthDisplay = rundown && rundown.display && rundown.display.displaySize && rundown.display.displaySize.width ? parseInt(rundown.display.displaySize.width) : 0;
				if (this.rundown.background_color === 'transparent') this.rundown.background_color = '#FFFFFF';
				$('html.md-theme-default').css('background-color', this.rundown.background_color);
				if (isReset) this.fetchItems();
				this.setBackground();
			};
			const errorCallback = () => {
			};
			rundownsApi.getBySlug(this.slug, callback, errorCallback);
		},
		fetchItems() {
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
				rundown_id: rundownId,
			};

			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.items.forEach((item) => {
					this.onStartPlay(item);
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		onStopAll(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_live = 0;
					tmpItem.is_play_preview = 0;
				}
			}
		},
		onStopAllPreview(items) {
			for (let index = 0; index < items.length; index++) {
				const tmpItem = this.items.find(item => item.id === items[index].id);
				if (tmpItem && !tmpItem.is_locked) {
					tmpItem.is_play_preview = 0;
				}
			}
		},
		setBackground() {
			this.backgroundColor = this.rundown ? this.rundown.background_color : '#FFFFFF';
			if (this.backgroundColor === 'transparent') this.backgroundColor = '#FFFFFF';
		},
	},
	computed: {
		slug() {
			return atob(this.$route.params.slug);
		},
		room() {
			const slug = atob(this.$route.params.slug);
			const room = `rundown_${slug}`;
			return room;
		},
		visibleElements() {
			const filter = item => (this.type === 'live' ? item.is_play_live === 1 : item.is_play_preview === 1);
			return this.items.filter(filter);
		},
		activeBgColor() {
			if (this.backgroundColor === '#FFFFFF' && !this.isBgToggled) return this.whiteTransparentBg;
			if (this.backgroundColor === '#FFFFFF' && this.isBgToggled) return this.darkTransparentBg;
			return this.backgroundColor === '#FFFFFF' || this.backgroundColor === '#00FF00' ? this.darkTransparentBg : this.whiteTransparentBg;
		},
	},
	watch: {
	},
};
</script>

<style lang="scss">
html {
	-webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}
.transition {
	position: absolute;
	-webkit-animation-name: transition;
	-webkit-animation-duration: .5s;
	animation-name: transition;
	animation-duration: .5s;
	}

	@keyframes transition {
	from {
		opacity : 0;
	}
	to {
		opacity : 1;
	}
}
</style>
